var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048",
    width: 128,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(929)",
    d: "m0 0h184l54 8 48 9 41 9 52 13 39 12 35 12 34 13 28 12 33 16 22 11 10 6 14 7 24 14 19 12 16 10 15 10 20 14 19 14 17 13 10 8 13 11 11 9 13 12 10 9 24 22 38 38 7 8 9 10 7 8 9 10 11 14 11 13 10 13 12 16 12 17 14 20 14 22 14 23 9 15 15 27 9 17 8 16 19 40 20 47 12 31 12 36 7 24 15 58 13 63 7 31v238l-13 58-8 40-16 64-17 56-9 25-8 21-18 42-16 34-14 27-8 14-14 24-10 17-10 15-15 24-9 12-13 18-10 13-10 14-11 14-9 10-9 11-7 7-7 8-16 17-12 13-11 11-4 5-8 7-17 16-10 9-11 10-8 7-14 12-20 16-13 10-13 9-19 14-24 16-24 15-20 12-21 12-16 9-25 13-16 8-25 12-34 14-46 17-55 17-42 11-46 11-49 11-21 5h-243l-35-10-32-8-54-12-43-11-39-12-29-10-30-12-42-18-30-14-32-16-46-27-19-12-16-10-17-12-18-13-21-16-16-12-13-11-11-9-11-10-8-7-10-9-15-14-7-7-6-5v-2l-4-2v-2l-4-2-12-13-10-10-7-8-15-16-7-8-11-13-8-10-13-16-13-17-14-19-11-16-16-24-16-26-15-26-13-24-9-17-11-23-13-29-11-27-9-24-14-41-13-44-8-33-12-55-8-44-7-45v-195l5-25 11-59 10-46 10-40 17-56 9-25 11-28 11-26 11-25 15-31 10-19 15-27 9-15 10-17 7-10 7-11 19-28 33-44 13-16 12-14 11-12 15-16 24-26 21-21 8-7 7-7 8-7 12-11 13-12 11-9 16-13 20-15 19-14 13-9 39-26 22-13 24-14 24-13 32-16 42-19 33-13 28-10 34-11 44-12 40-10 50-10 38-7z",
    className: "secondary",
    fill: "#FD9A33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1573,274)",
    d: "m0 0h7l5 5 3 2v2l4 2 3 3v2l4 2 4 5 9 6 5 5 7 8 8 7v2l5 2 1 3h2l2 5 4 2 6 4 5 6 3 1 5 5 3 2v2h2l7 8 7 6v2h2l5 6 13 10v2l4 2 1 3h2v2h2l5 5 6 7 11 9 1 3h2l4 4v2h2l7 8 8 7 5 5 7 8 8 7 6 5 6 8 14 14 1 3h2v2h2l2 4 6 4 10 12 2 1v2h2l6 7 5 4 5 5 4 3v3h2v2h2v2l4 2 8 7 5 7 6 4 7 8 9 7 8 7 6 4 7 5v2l6 2 5 5 1 4 4 2v2l4 2 13 10 5 3 7 3 3 3v2l5 2 4 2 13 31 10 26 15 47 11 43 8 32 11 54 7 31v238l-13 58-8 40-16 64-17 56-9 25-8 21-18 42-16 34-14 27-8 14-14 24-10 17-10 15-15 24-9 12-13 18-10 13-10 14-11 14-9 10-9 11-7 7-7 8-16 17-12 13-11 11-4 5-8 7-17 16-10 9-11 10-8 7-14 12-20 16-13 10-13 9-19 14-24 16-24 15-20 12-21 12-16 9-25 13-16 8-25 12-34 14-46 17-55 17-42 11-46 11-49 11-21 5h-243l-42-12 1-5 3-2-1-5-4-5-6-3-3-4v-2h-2l-3-3v-2h-2l-1-3-4-4-3-7-7-8-2-5h-2l-7-8-10-10-5-6-6-5-6-7v-2l-3-1-4-5-4-2-7-8-3-2v-2h-2l-5-6-8-7v-2l-3-1-5-5v-2l-4-2-6-4v-2h-2l-4-5v-2h-2l-6-8-7-6-7-8-8-6-2-5-3-1-3-5-2-1v-3h-3l-7-8-6-5-2-1v-2l-4-2-5-6v-2h-2l-4-4v-2h-2l-7-8-9-8-7-8-10-12-5-10-5-9-4-14-3-21-1-17v-194l1-156 1-77v-48l1-1 34-1 64-1 30-1 11-1 41-1h74l10 1 1-1 3-66 3-95 1-19v-19l1-3h2l2-5 15-6 14-7 18-11 17-12 14-12 13-12 4-5 5-5 8-9 6-8 1-2h2l2-5 11-19 7-12 11-25 7-21 6-23 3-18 2-23 1-20 1-35v-433h2l3 13 2 3v11l-2 4 2 3 4 2 3-1-1-3h3l-1-6v-2l4-1 6 3v2l4 2 9 8 5 3 5 6 8 7v2l4 2 7 7 2 1v2l4 2 9 8 17 17 7 6v2l4 2 10 8 6 7 12 10v2h2v2l4 2 3 4v2l4 1 8 10 2 9 5 6h3l-1 7-5 12-8 28-5 27-4 39-1 29-1 72v115l2 71 2 26 5 24 9 22 9 16 10 13 14 14 16 11 19 10 16 6 6 4 10 2 36 3 50 2 78 1 69 2h18v-36l1-145 1-102 1-424 1-15 4-7-1-7 1-2z",
    className: "background",
    fill: "#E77E12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(775,285)",
    d: "m0 0h23l3 3 1 27 1 48v249l2 23 5 13 4 8 7 8 16 8 13 4h23l16-6 9-6 9-9 5-10 3-19 1-15v-61l-1-70v-193l2-2h43l79 1 12 1 2 2 1 60 1 90v283l-1 35-2 33-3 23-5 21-7 23-9 21-8 16-12 21-5 8h-2l-2 5-11 13-5 6h-2l-2 4-10 10-8 7-16 13-20 13-19 11-20 8-5 3-5 4-11 3-37 6-33 3-22 1h-51l-47-4-40-5-27-5-3-3-10-3-12-5-16-8-18-10-9-6-14-10-17-14-16-15-10-11-13-18-9-15-12-24-8-20-7-25-4-22-3-27-1-23-2-114v-63l1-138 1-45 1-108 1-3 2-1 11-1h52l50 1 10 1 2 1v153l2 190 4 18 4 7 8 7 10 7 14 7 13 3h9l6-2 9-1 13-7 9-7 10-12 4-8 3-14 1-7 1-21v-49l-1-81v-136l-2-40 1-8 6-3z",
    fill: "#DDEEFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1543,257)",
    d: "m0 0h20l2 2 1 10 2 77 1 83v403l-1 145-1 36-6 1-44-1-37-1-78-1-50-2-36-3-10-2-8-5-18-7-17-9-16-12-15-15-10-14-9-17-8-21-4-21-2-26-2-71v-115l1-72 1-29 4-39 6-31 7-24 6-15 7-16 12-23 14-22 12-17 8-9 7-8 9-10 8-8 8-7 12-10 11-8 21-14 17-10 23-12 24-10 10-3 1-1 10-2 15-4h4v-2l26-4 29-2 28-1z",
    fill: "#DEEEFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1505,1218)",
    d: "m0 0h52l8 1 1 50v442l-2 21-5 18-6 15-7 10-8 11-11 12-17 13-11 7-12 6-13 6-15 5-7 2-8 1h-10l-18-4-19-6-15-6-14-8-12-8-11-8v-2h-2v-2l-4-2-6-5-2-5h-2l-7-11-8-16-6-13-3-11-4-24-2-38v-192l2-82 1-99 2-72 1-1 78-1 53-2 14-1z",
    fill: "#5F5552"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(789,1219)",
    d: "m0 0h74l9 1v14l-1 27-1 75v94l1 181 1 43v40l-2 22-3 17-5 17-8 18-8 13-11 12-9 9-19 13-18 10-30 10-15 3h-16l-19-3-14-5-14-8-12-9-11-9-13-12-11-11-11-14-7-11-4-11-3-13-2-15-1-17v-194l1-156 1-77v-48l1-1 34-1 64-1 30-1 11-1z",
    fill: "#605653"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(789,1219)",
    d: "m0 0h74l9 1v14l-1 27-1 75v94l1 181 1 43v40l-2 22-3 17-5 17-8 18-8 13-11 12-9 9-19 13-18 10-9 1-4 2-10 1h-10l-4-1h-5v-3l-5-1-4-10-2-17 1-15-1-59 1-33v-141l1-14v-56l1-32v-29l1-26v-36-2-6-2l1-5-1-1v-5-3-12-2l1-8 2-6 1-5-1-4-3-2h3l1-4 2-4h-2l-2-6 4-5v-4h4v-3l-3-1-1-4-2-6h3l-1-5-3-5-2-2 1-4h-3l-1-10-11-2v-4l-36 1-4 1-3-1-15 1h-56l-4 1v-3l34-1 64-1 30-1 11-1z",
    fill: "#4D4544"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1505,1218)",
    d: "m0 0h52l8 1 1 50v442l-2 21-5 18-6 15-7 10-8 11-11 12-17 13-12 6-13 6-7 2h-3l-1 2-8 1-11-2-4-2v-2l-6-1v-2l-4-1-3-8-2-13v-16l1-20v-12l-1-28v-7l-1-1v-30l1-19 1-25v-14l1-44v-12l-1-25v-34l-1-7 1-11v-34l-1-5 1-21v-12l1-1v-10l-1-6 1-5v-89l-1-19v-23l-1-16v-21l-2-1 1-6-11 1h-19l-8 1h-22l-3 1-7-1h-35v-1l13-1 93-3 14-1z",
    fill: "#4D4544"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1298,999)",
    d: "m0 0 5 2 6 3 28 3 40 2 25 1 78 1 69 2h17l1 2v130l-1 73-1 1h-60l-55 1-14 1-53 2h-79v-45l1-28 1-14v-74l-1-17v-21l-3-18z",
    fill: "#FEDD88"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(883,1013)",
    d: "m0 0 3 1-2 3h-2v25l-1 17-4 121-2 39-2 2-10-1h-74l-41 1-11 1-30 1h-101l-1-79v-39l1-3v-85l12 3 23 4 34 4 47 4h51l35-2 25-3 37-6 9-4z",
    fill: "#FEB23E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,293)",
    d: "m0 0h1l1 11 5 3 5 11 2 1 1 3 8 4 5 1 9 3 2 4 6 5 4 4 9 5 3 3v2l5 2 9 6 4 5 4 3v2l5 2 7 4 5 8 5 3h5v-5h1l1 7h1l2 160v61l-2 24-3 13-6 9-10 10-14 7-9 3h-23l-15-5-14-7-9-10-7-17-2-11-1-15z",
    className: "background",
    fill: "#E77E12"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(575,327)",
    d: "m0 0 8 1v2l12 2 8 5 9 8 9 7v3l5 2 9 5 7 6 6 4 1 3 5 2 6 5 7-2 1 1 1-16h1l1 30v99l-1 51 1 25 1 2 1-24h1v49l-1 25-1 9-4 12-3 3v5l4-5-1 5-10 13-8 7-8 5-6 1v-3l4-8 1-3-2-2-6 2-8 1-2 3-8 1-1 1h-8l-15-8-6-6v-2h-2l-7-8-3-7-4-9-8-3-3-5v-62l1-5v-24l1-78-1-50v-26l3-9h2l1 8v10 3l2 7 1 6h2l-1-13 1-11v-9l-1-4 1-6-1-1v-19l4-6h2z",
    className: "background",
    fill: "#E77E12"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1437,1012)",
    d: "m0 0 129 1 1 2v130l-1 73-1 1h-60l-69 1-2-3v-163l2-41z",
    fill: "#FEB23E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(606,1017)",
    d: "m0 0 12 3 23 4 34 4 47 4h51l35-2 25-3 13-2h5l-4 2-25 4-22 2-20 1h-46l1 32 1 23 1 63 1 54 1 14h-2v2l-30 1h-101l-1-79v-39l1-3z",
    fill: "#FEDD88"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(870,1021)",
    d: "m0 0 3 1v13l-4 4h-2l-1 7-4 15v11l-3 6-8 4-3 1 2-8-7 2-5-1-2 3 6-1 3 6-5 2h-10l-5 5-10 2-8 2v3l-11 6-1 5-4 4-5-1-3 5-1 2-10 5-4-1-5-8-3-1-2 6-4 3-4-1-2-7-2 10h-2v13h-2l1 13v7l-2 12v50l-4 1 1-2-1-16-1-51-1-71-1-21v-26l46-1 33-2 29-4 9-2 7-2z",
    fill: "#FFC656"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(429,753)",
    d: "m0 0 3 4 3 6 1 10h2l2 9 2 8 6 2 4 9 4 8 4 17 2 13 4 20 3 11 4 16 5 12 8 16 7 11 9 10 7 9 13 14-1 5h-4l-6-7-2-1v-2l-4-2-3-3-5-3v-2l-4-2-5-6-3-4-3-7-3-4v-2h-2l-5-6-4-7-10-13-8-16v-2h-2l-7-17-7-25-4-22-1-7-1-30v-19z",
    fill: "#FCFCFC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1199,788)",
    d: "m0 0 3 1 1 11-1 13 1 3 1 20 3 7 1 1v11l3 9 4 13 7 21 6 17 7 15 11 21 7 7 7 9 22 16 10 2 10 1 23 9 22 4 2 3-4 1-6 2-2 1h-21l-10-2-8-5-18-7-17-9-16-12-15-15-10-14-9-17-8-21-4-21-2-26z",
    fill: "#FCFCFC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(555,291)",
    d: "m0 0h1v18l1 23 1 162 1 91v36l3 5 7 2 3 5 6 15 4 2 1 3h2l7 8 14 7h8l1-1h8l2-4 15-3 2 5-3 5-3 6 4 1-6 3-9 1-6 2h-9l-15-4-17-9-11-10-5-5-4-11-2-11-2-190v-145z",
    fill: "#FE9D36"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1270,987)",
    d: "m0 0 6 2 11 5 11 4 5 8 3 18v22l1 26v65l-1 20-1 23v52l-1 26-2 1v-31l-2-43-2-19v-14l-2-30-1-31-1-15-2-17v-25l-2-11-3-13-1-10-5-4-12-6z",
    fill: "#FE9B33"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,363)",
    d: "m0 0h1v249l2 23 5 13 4 8v3l-4-5-5-10-6-16-1-1-3-18-1-11-1-2-1-19v-91l2-13 1-13 1-28 1-29 2-11 2-16v-10z",
    fill: "#D7DEE7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(803,384)",
    d: "m0 0h1l2 176 1 55 4 2 3 3 4 12 6 11 5 7 9 7 8 4 12 3 5 2 2-4h15l3 2 2 9-12 4h-23l-15-5-14-7-9-10-7-17-2-11-1-15z",
    fill: "#FEA43C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,289)",
    d: "m0 0h2l-1 111-1 45-1 138v63l2 114 1 23 3 27 4 22 7 25 4 10-1 3-7-18-5-17-3-11-4-29-3-53-1-50v-193l-1-83-1-48-1-67 3-8z",
    fill: "#FFB440"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,987)",
    d: "m0 0 6 1 5 5 14 7 4 1 9-4h2v-2l14 1 16 5 24 8 25 6 13 4 9 1v1l-5 1v3l-1 3h-17l-38-5-20-4-3-3-10-3-12-5-16-8-18-10z",
    fill: "#FBFCFC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1437,1012)",
    d: "m0 0 77 1v1l-57 3-3 2v2l2 1 1 8-3 3-2 5-5 1-2-1-1 4h-2l-1 9v33l-1 8v47l-1 32v16l-1 14v16l15 1-3 2h-14l-2-3v-163l2-41z",
    fill: "#FEC655"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1053,349)",
    d: "m0 0h1l1 90v283l-1 35-2 33-1 10h-1l1-59v-37l-1-57v-84l1-23v-31l1-14v-47z",
    fill: "#D7DEE7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,291)",
    d: "m0 0h2l2 46v136l1 81v49l-1 21-3 17-2 7h-2l-4 5v-7l4-5 3-10 1-9 1-36h-1l-1-14-1-2-1-36 1-43v-163z",
    fill: "#FEB33F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(553,298)",
    d: "m0 0h1l1 35v110l2 190 2 11-1 4-2-5-2-11-1-18-2-15-3-27v-17l1-15 2-49v-48l1-46v-93z",
    fill: "#D7DEE7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(915,304)",
    d: "m0 0h1l2 19v47l-1 3h2l1 10h-3l2 2 2 10-1 3v7l1 11-1 11v7l1 8v46l-1 6 1 9v67h-3v27h-1l-1-47-1-70z",
    fill: "#D7DEE7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1543,257)",
    d: "m0 0h20l2 2 1 10 2 77 1 83v90h-1l-1-89-1-59-3-100-1-11-17 4-9 1-38 1-30 2-26 5-4 1-5-1 3-2 15-4h4v-2l26-4 29-2 28-1z",
    fill: "#D7DEE6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1290,996)",
    d: "m0 0 5 1 3 1 5 8 3 18v22l1 26v65l-1 20-1 21h-1l-1-14-1-4v-1l-1-2-1-89-1-57-1-10-6-2-2-1z",
    fill: "#FFB33F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1054,349)",
    d: "m0 0h1l1 79 1 161v136l-2 48-1 16-4 27-2 2 1-12 2-16 2-33 1-35z",
    fill: "#FEB64D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1547,253)",
    d: "m0 0 13 1 6 3 1 2 2 20v150h-1l-1-83-2-77-1-10-1-1h-20l-5 1-45 2-18 2-16 2v-2l14-2h7v-2l25-3 28-1z",
    fill: "#FFB643"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(673,289)",
    d: "m0 0 2 4 2 6v21l-1 46v62l2 136-1 47-1 16-2 4 1-28v-49l-1-81v-136l-2-40z",
    fill: "#D7DEE7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1450,997)",
    d: "m0 0h3l3 2h7l4 2v2h16l7 2 9 2 4 2 7 1v1l-40-1-37-2-1-2 2-5 6-1h4 3z",
    fill: "#D7DEE7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(555,291)",
    d: "m0 0h1v18l1 23v162l-1 40h-1l-1-91v-145z",
    fill: "#FFC964"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(875,1018)",
    d: "m0 0 3 1-13 4-37 6-33 3-22 1h-51v-1l14-1h10v-2l9-2 14-1 17 1 1 1h17l10-1 4-2h16l16-2 11-2z",
    fill: "#D7DEE7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,646)",
    d: "m0 0h1l2 114 1 23 3 27 4 22 7 25 4 10-1 3-7-18-5-17-3-11-4-29-3-53v-38z",
    fill: "#FFC258"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(449,874)",
    d: "m0 0 3 4 8 15 9 12 6 9 2 4h2l6 9 2 5 6 8 5 5 3 2v3l3 1 7 8 3 4-4-2-17-16-10-11-13-18-9-15-12-24z",
    fill: "#DDECF8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1213,922)",
    d: "m0 0 3 4 8 14 6 7 1 3 5 5 1 3h2v2h2v2l4 2 11 9 15 12 15 7 8 2 14 6v3l8 1v1h-7l-16-8-13-5-17-9-16-12-15-15-10-14-9-17z",
    fill: "#D9E3ED"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(427,641)",
    d: "m0 0h1l3 21v38l-1 12 1 20-1 14-2 2-1-21v-28l-1-44 1-6-1-6z",
    fill: "#FDFDFD"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(556,494)",
    d: "m0 0h2l1 91v12h-2v36h-1z",
    fill: "#FEB23F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1305,1069)",
    d: "m0 0 2 3v65l-1 20-1 21h-1l-1-14-1-4v-1-37l1-2 1-11v-34z",
    fill: "#FFC655"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,583)",
    d: "m0 0h1l1 62 2 5-1 6 1 45v26l-1 33h-1l-2-114z",
    fill: "#D8E2EC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(881,1017)",
    d: "m0 0 1 4v21l-1 17-4 121h-1v-29l2-79v-52z",
    fill: "#FE9A33"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,292)",
    d: "m0 0h1v108l-1 45h-1v-120l-1-11v-16z",
    fill: "#FFDE89"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(461,285)",
    d: "m0 0h81l7 2v2l-56-1h-61v-2z",
    fill: "#FFC55E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,554)",
    d: "m0 0h2v49l-1 21-3 17-2 7h-2l-4 5v-7l4-5 3-10 1-9 1-28z",
    fill: "#FFB440"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(874,1169)",
    d: "m0 0h1v30l-1 22-4-2-1-1h-5l4-7 1-13 1-5 3-20z",
    fill: "#FEC757"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1566,278)",
    d: "m0 0h1v26h2v125h-1l-1-83-1-38z",
    fill: "#FFC660"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,1223)",
    d: "m0 0h74v1l-18 1h-8l-4 1-3-1-15 1h-56l-4 1v-3z",
    fill: "#514947"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1302,1163)",
    d: "m0 0 2 1 1 16v52l-1 26-2 1z",
    fill: "#FCAB38"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,494)",
    d: "m0 0h1l1 46 1 7v39h-1l-1-14-1-2-1-36z",
    fill: "#FE9A33"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1407,1221)",
    d: "m0 0h7l-2 2-11 2h-26l-3 1-7-1h-35v-1l13-1z",
    fill: "#4F4746"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(467,909)",
    d: "m0 0 4 4 7 10 7 6 7 10 5 4 4 4v3l3 1 7 8 3 4-4-2-17-16-10-11-13-18-3-5z",
    fill: "#D7DEE7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(427,783)",
    d: "m0 0h1l3 27 4 22 7 25 4 10-1 3-7-18-5-17-3-11-4-29v-8z",
    fill: "#FFB542"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1537,256)",
    d: "m0 0h25v1l-19 1-5 1-45 2-18 2-16 2v-2l39-5 27-1z",
    fill: "#FFDB84"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1255,400)",
    d: "m0 0 2 1-1 3h-2l-1 5-2 3h-2l-1 4-10 18-10 20-3 1 2-6 10-20 12-20z",
    fill: "#FAF3DF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(673,597)",
    d: "m0 0h1l1 27-3 17-2 7h-2l-4 5v-7l4-5 3-10 1-9z",
    fill: "#FEAB40"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,1976)",
    d: "m0 0 6 3 1 3-5 1-9 1-4-2-1-4 1-1 8 1z",
    className: "background",
    fill: "#E77E12"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,291)",
    d: "m0 0h2l1 27-1 11-2-1z",
    fill: "#FFC863"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1343,1223)",
    d: "m0 0h35l-4 3-10-1h-34v-1z",
    fill: "#4D4544"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(557,580)",
    d: "m0 0h1l1 17h-2v36h-1v-52z",
    fill: "#FEB849"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(427,783)",
    d: "m0 0h1l4 36h-2l-3-16-1-16z",
    fill: "#FFBB4C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1289,993)",
    d: "m0 0 5 1 14 6v3l8 1v1h-7l-20-10z",
    fill: "#DCEBF6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(548,987)",
    d: "m0 0 6 1 5 5 12 6 1 3-5-2-18-10z",
    fill: "#F1F5F7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1258,976)",
    d: "m0 0 4 2 11 8 13 6 3 1v2l-9-3-17-9z",
    fill: "#DAE6F0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1537,256)",
    d: "m0 0h25v1l-19 1-5 1h-15l2-2z",
    fill: "#FFDE89"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1213,922)",
    d: "m0 0 3 4 8 14 6 7-1 2-5-4-9-16-2-4z",
    fill: "#DAE5F0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(674,585)",
    d: "m0 0h2v18l-1 17h-1l-1-26z",
    fill: "#FEBB4D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,1224)",
    d: "m0 0h39v1l-7 1h-28l-4 1z",
    fill: "#4D4544"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(485,929)",
    d: "m0 0 4 2 8 10 4 6-4-2v-2l-4-2-5-6-3-4z",
    fill: "#DEEFFB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,631)",
    d: "m0 0h1l-1 9-4 10-3 3v-7l4-5z",
    fill: "#FE9A33"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1503,1813)",
    d: "m0 0 2 1-6 4-16 8-3-1 5-3 16-8z",
    fill: "#605653"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1235,434)",
    d: "m0 0 2 1-9 19-3 1 2-6z",
    fill: "#F5F1E0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1301,347)",
    d: "m0 0 2 1-11 10-4 5-4 2 2-4 13-13z",
    fill: "#FDF1D0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(761,1980)",
    d: "m0 0h5l6 3v2l-7 1-4-4z",
    className: "background",
    fill: "#E77E12"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(608,1725)",
    d: "m0 0h1l3 16 1 5-3-1-3-12z",
    fill: "#F59E2C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(449,874)",
    d: "m0 0 3 4 8 15v4l-3-4-8-16z",
    fill: "#D9E4EF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1244,420)",
    d: "m0 0v3l-6 11-3-1 7-12z",
    fill: "#F8F5E8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(604,1089)",
    d: "m0 0 2 1 1 12-2 8h-1z",
    fill: "#FFB33E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,285)",
    d: "m0 0h7l7 2v2h-6l-1-1-8-1z",
    fill: "#FFBB4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.ab4afff938e37fc6fe6d3696c7693af1.svg";
export { ForwardRef as ReactComponent };